"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTooltip = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _templateObject;
var StyledTooltip = exports.StyledTooltip = (0, _styledComponents["default"])(_reactstrap.Tooltip)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  .tooltip-inner {\n    text-align: left;\n    font-size: 12px;\n    max-width: 245px;\n    border-radius: 3px;\n\n    .icon-spacer {\n      width: 16px;\n      display: inline-block;\n      text-align: center;\n    }\n  }\n"])));